module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C2816"
  }, [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Abbreviations ")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ACGME ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Accreditation Council for Graduate Medical Education (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ACLU ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("American Civil Liberties Union ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ACOG ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("American College of Obstetricians and Gynecologists ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ALI ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("American Law Institute ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ALRA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Abortion Law Reform Association (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("AMA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("American Medical Association ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("AMCAL ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Association for the Modernization of Canadian Abortion Laws ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("AMPAC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("American Medical Political Action Committee ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ASA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Association for the Study of Abortion (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("BMA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("British Medical Association ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("BPAS ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Birmingham Pregnancy Advisory Service (later, British Pregnancy Advisory Service) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("CARAL ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Canadian Association for the Repeal of Abortion Laws (1973–80) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("CARAL ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Canadian Abortion Rights Action League (1980–2002) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("CBA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Canadian Bar Association ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("CCTA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("California Committee on Therapeutic Abortion ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("CLSC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("centre local de services communitaires ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("CMA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Canadian Medical Association ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ERA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Equal Rights Amendment (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FLQ ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Front de libération du Québec ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FPD ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Family Planning Division (Canada) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("G8 ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Group of Eight ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("GOP ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Republican Party (“Grand Old Party”) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("GP ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("general practitioner ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ICMCA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Illinois Citizens for the Medical Control of Abortion ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("LARC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Labour Abortion Rights Committee (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("LPAS ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("London Pregnancy Advisory Service ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NAC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Abortion Campaign (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("NAF ")])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Abortion Federation (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NARAL ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Association for the Repeal of Abortion Laws (United States, 1969–73) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NARAL ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Abortion Rights Action League (United States, 1973–present) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NCCB ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Conference of Catholic Bishops (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NDP ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("New Democratic Party (Canada) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NHS ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Health Service (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NORC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Opinion Research Center ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NOW ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Organization for Women (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NRLC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Right to Life Committee (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("NWPC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("National Women’s Political Caucus (United States) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("OB/GYN ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("obstetrician/gynecologist ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("OECD ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Organisation for Economic Co-operation and Development ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("OMA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Ontario Medical Association ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("PCP ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("primary care practitioner ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("PLP ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Parliamentary Labour Party (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("PPFA ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Planned Parenthood Federation of America ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("PQ ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Parti Québécois ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("RCOG ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Royal College of Obstetricians and Gynaecologists (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("SPUC ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Society for the Protection of Unborn Children (Britain) ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("ZPG ")]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Zero Population Growth (United States) ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d918e9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_List_of.vue
// module id = 66
// module chunks = 0